import { useState } from "react";
import { TabBox } from "src/Components";
import { Tab } from "src/Components/Tabbox/TabBox";
import { CollateralTabs } from "src/Interfaces/collateral";
import AdaptationManagement from "./AdaptationManagement";
import AdaptationReport from "./AdaptationReport";
import CoveredCall from "./CoveredCall";

const Collateral = () => {
  const [tabIndex, setTabIndex] = useState(CollateralTabs.AdaptationManagement);

  const tabsChildren: Tab[] = [
    {
      index: CollateralTabs.AdaptationManagement,
      title: "مدیریت تطبیق",
    },
    {
      index: CollateralTabs.AdaptationReport,
      title: "گزارش تطبیق",
    },
    {
      index: CollateralTabs.CoveredCall,
      title: "وضعیت وثیقه",
    },
  ];

  const getTabUI = () => {
    switch (tabIndex) {
      case CollateralTabs.AdaptationManagement:
        return <AdaptationManagement />;

      case CollateralTabs.AdaptationReport:
        return <AdaptationReport />;

      case CollateralTabs.CoveredCall:
        return <CoveredCall />;

      default:
        return <></>;
    }
  };

  return (
    <div className="flex flex-col justify-start items-start gap-3 w-full px-3">
      <div className="w-min">
        <TabBox
          activeTab={tabIndex}
          children={tabsChildren}
          onChange={(_, i) => setTabIndex(i)}
        />
      </div>
      {getTabUI()}
    </div>
  );
};

export default Collateral;
